import {
  ModalProps,
  ModalContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
  Button,
  createModalComponent,
} from "@shortsworks/ui";

interface Cafe24LoginContentProps {
  redirectUrl: string;
}

const Cafe24LoginContent = (props: ModalProps<Cafe24LoginContentProps>) => {
  const handleCafe24Login = () => {
    props.close(true);
    return window.location.assign(props.redirectUrl);
  };

  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>CAFE24 로그인</DialogTitle>
        <DialogDescription className="py-2">
          <div>
            카페24 로그인 세션이 만료되어 카페24 로그인 페이지로 이동합니다.
          </div>
          <div>
            쇼츠웍스의 카페24와 관련된 기능을 사용하려면 로그인이 필요합니다.
          </div>
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild></DialogClose>
        <Button onClick={handleCafe24Login} className="p-0 w-[104px] h-[40px]">
          확인
        </Button>
      </DialogFooter>
    </ModalContent>
  );
};

export const Cafe24LoginModal = createModalComponent(Cafe24LoginContent);
